// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"395":"69facf17","905":"5274780a"}[chunkId] + ".chunk.css";
};